"use client";

import React from "react";
import { ArrowRight, CircleCheck as CheckCircle2, ShieldCheck, Activity } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
const solutions = [{
  title: "Process Analytical Technology",
  badge: "Process Monitoring & PAT",
  url: "/ProcessAnalyticalTechnologyPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1776299/img/pat_process_analytical.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1776299/img/pat_process_analytical.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1776299/img/pat_process_analytical.png-wvc-sizes",
  alt: "Process analytical technology monitoring equipment in cleanroom",
  icon: Activity,
  description: "Real-time NIR and Raman process analyzers engineered for continuous manufacturing, blend uniformity, and critical quality parameter validation.",
  features: ["In-line and on-line real-time monitoring", "Non-destructive sample validation", "Seamless integration with control systems"]
}, {
  title: "Safety and Security",
  badge: "Hazard & Substance Screening",
  url: "/SafetyAndSecurityPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1776299/img/safety_security_analyzer.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1776299/img/safety_security_analyzer.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1776299/img/safety_security_analyzer.png-wvc-sizes",
  alt: "Safety and security handheld material identification analyzer",
  icon: ShieldCheck,
  description: "Handheld and portable identification systems for hazardous substances, raw materials, narcotics, and chemical defense applications.",
  features: ["Rapid point-of-need spectral analysis", "Comprehensive onboard threat libraries", "Ruggedized for field operations and border control"]
}];
export default function RelatedSolutions() {
  return <section id="relatedsolutions" data-nav="light" className="bg-background text-foreground py-20 md:py-28">
      <div className="page-container">
        <div className="mx-auto mb-14 max-w-2xl text-center">
          <Badge variant="secondary" className="mb-3 font-medium">
            Explore Capabilities
          </Badge>
          <h2 className="font-default text-3xl font-bold tracking-tight sm:text-4xl">
            Related Analytical Solutions
          </h2>
          <p className="text-muted-foreground mt-4 text-base sm:text-lg">
            Explore complementary instrumentation and support services tailored
            for laboratory compliance and process environments.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {solutions.map((item, i) => {
          const IconComponent = item.icon;
          return <div key={item.url} data-index={i} className="flex">
                <Card className="border-border bg-card shadow-sm hover:shadow-md flex flex-col justify-between overflow-hidden border transition-[box-shadow,transform] duration-200 hover:-translate-y-0.5">
                  <div>
                    <div className="relative aspect-16/9 w-full overflow-hidden bg-muted">
                      <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-300 hover:scale-105" />
                      <div className="absolute top-4 left-4">
                        <Badge variant="default" className="shadow-xs gap-1.5">
                          <IconComponent className="size-3.5" />
                          <span>{item.badge}</span>
                        </Badge>
                      </div>
                    </div>

                    <CardHeader className="pt-6 pb-2">
                      <CardTitle className="font-default text-2xl font-bold">
                        {item.title}
                      </CardTitle>
                      <CardDescription className="text-muted-foreground mt-2 text-base leading-relaxed">
                        {item.description}
                      </CardDescription>
                    </CardHeader>

                    <CardContent className="pt-4">
                      <ul className="space-y-2.5">
                        {item.features.map((feature, featureIndex) => <li key={featureIndex} data-index={featureIndex} className="flex items-start gap-2.5 text-sm text-foreground/90">
                            <CheckCircle2 className="text-primary mt-0.5 size-4 shrink-0" />
                            <span>{feature}</span>
                          </li>)}
                      </ul>
                    </CardContent>
                  </div>

                  <CardFooter className="pt-6 pb-6">
                    <Button asChild variant="default" className="w-full sm:w-auto">
                      <Link to={item.url} className="inline-flex items-center gap-2">
                        <span>Explore {item.title}</span>
                        <ArrowRight className="size-4" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}